import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import {
    Box,
    Drawer,
    List,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Collapse,
    Typography,
    IconButton,
    Tooltip,
} from '@mui/material';
import {
    ExpandLess,
    ExpandMore,
} from '@mui/icons-material';
import { useNavigate, useLocation, Link as RouterLink } from 'react-router-dom';
import { ReactComponent as PepwiseLogoIcon } from '../../assets/PepWise2.0/Pepwise logo Icon.svg';
import { ReactComponent as PepwiseLogo } from '../../assets/PepWise2.0/Pepwise logo1.svg';
import { ReactComponent as XopsIcon } from '../../assets/PepWise2.0/D&AI Executive Dashboards.svg';
import { ReactComponent as XopsSelectedIcon } from '../../assets/PepWise2.0/D&AI Monthly XOps_Selected.svg';
import { ReactComponent as DataObservabilityIcon } from '../../assets/PepWise2.0/Data Observability Unclicked.svg';
import { ReactComponent as ProgramExecutiveIcon } from '../../assets/PepWise2.0/Program Executive Dashboards Unclicked.svg';
import { ReactComponent as FinopsIcon } from '../../assets/PepWise2.0/FinOps Unclicked.svg';
import { ReactComponent as PlatformIcon } from '../../assets/PepWise2.0/Platform Obs Clicked Area.svg';
import { ReactComponent as MLIcon } from '../../assets/PepWise2.0/ML Observability Unclicked.svg';
import { ReactComponent as KpiIcon } from '../../assets/PepWise2.0/DataKPIsAlerts.svg';
import { ReactComponent as DataEstateIcon } from '../../assets/PepWise2.0/DataEstate Executive Dashboards.svg';
import { ReactComponent as ProductCatalogIcon } from '../../assets/PepWise2.0/Product Catalog.svg';
import { ReactComponent as ProductSuccessIcon } from '../../assets/PepWise2.0/Product_Success.svg';
import { ReactComponent as PlatformSelectedIcon } from '../../assets/PepWise2.0/Platform Observability Selected.svg';
import { ReactComponent as TerradataIcon } from '../../assets/PepWise2.0/simple-icons_teradata.svg';
import { ReactComponent as TableauIcon } from '../../assets/PepWise2.0/simple-icons_tableau.svg';
import { ReactComponent as DataGrowthIcon } from '../../assets/PepWise2.0/material-symbols_chart-data.svg';
import { ReactComponent as DataBricksIcon } from '../../assets/PepWise2.0/simple-icons_databricks.svg';
import { ReactComponent as PrestoIcon } from '../../assets/PepWise2.0/simple-icons_presto.svg';
import { ReactComponent as PlatformHealthIcon } from '../../assets/PepWise2.0/platform-health-icon.svg';
import { ReactComponent as PowerBIIcon } from '../../assets/PepWise2.0/simple-icons_powerBI.svg';
import { ReactComponent as DataManagementIcon } from '../../assets/PepWise2.0/simple-icons_DataManagement.svg';
import { ReactComponent as EnterprisePlatformIcon } from '../../assets/PepWise2.0/Enterprise Platform Modernization Dashboard.svg';
import { ReactComponent as XopsIntelligenceIcon } from '../../assets/PepWise2.0/xOPSIntelligenceIcon.svg';

import { ReactComponent as TerradataActiveIcon } from '../../assets/PepWise2.0/Teradata_Selected_White.svg';
import { ReactComponent as TableauActiveIcon } from '../../assets/PepWise2.0/Tableau_Selected_White.svg';
import { ReactComponent as DataGrowthActiveIcon } from '../../assets/PepWise2.0/DataGrowth_Selected_White.svg';
import { ReactComponent as DataBricksActiveIcon } from '../../assets/PepWise2.0/Databricks_Selected_White.svg';
import { ReactComponent as PrestoActiveIcon } from '../../assets/PepWise2.0/Presto_Selected_White.svg';
import { ReactComponent as PlatformHealthActiveIcon } from '../../assets/PepWise2.0/Platform_health_Selected_White.svg';
import { ReactComponent as PowerBIActiveIcon } from '../../assets/PepWise2.0/PowerBI_Selected_White.svg';
import { ReactComponent as DataManagementActiveIcon } from '../../assets/PepWise2.0/DMF_Selected_White.svg';
import { ReactComponent as EnterprisePlatformActiveIcon } from '../../assets/PepWise2.0/Enterprise Platform Modernization Dashboard_Selected_White.svg';

import { ReactComponent as DataOpsClickedIcon } from '../../assets/PepWise2.0/Data Observability Clicked.svg';
import { ReactComponent as DataOpsIcon } from '../../assets/PepWise2.0/DataOps.svg';
import { ReactComponent as ProgramOpsIcon } from '../../assets/PepWise2.0/ProgramOps.svg';
import { ReactComponent as SectorExecutiveIcon } from '../../assets/PepWise2.0/SectorExecutive.svg';
import { ReactComponent as IbpIcon } from '../../assets/PepWise2.0/IBP.svg';
import { ReactComponent as MdipIcon } from '../../assets/PepWise2.0/MDIP.svg';
import { ReactComponent as IbpActiveIcon } from '../../assets/PepWise2.0/IBP_Selected_White.svg';
import { ReactComponent as MdipActiveIcon } from '../../assets/PepWise2.0/MDIP_Selected_White.svg';
import { ReactComponent as RMIcon } from '../../assets/PepWise2.0/Resource Mapping.svg';
import { ReactComponent as PlatformCostIcon } from '../../assets/PepWise2.0/Platform Cost.svg';
import { ReactComponent as RMActiveIcon } from '../../assets/PepWise2.0/Resource Mapping_Selected_White.svg';
import { ReactComponent as PlatformCostActiveIcon } from '../../assets/PepWise2.0/Platform Cost_Selected_White.svg';
import { ReactComponent as KPIStoreIcon } from '../../assets/PepWise2.0/KPI Store.svg';
import { ReactComponent as AlertIcon } from '../../assets/PepWise2.0/Alerts.svg';
import { ReactComponent as KPIStoreActiveIcon } from '../../assets/PepWise2.0/KPI Store_Selected_White.svg';
import { ReactComponent as AlertActiveIcon } from '../../assets/PepWise2.0/Alerts_Selected_White.svg';
import { ReactComponent as DataSustainActiveIcon } from '../../assets/PepWise2.0/DataSustainActive.svg';
import { ReactComponent as SectorExecutiveActiveIcon } from '../../assets/PepWise2.0/Sector Executive_Selected_White.svg';
import { ReactComponent as ProgramOpsActiveIcon } from '../../assets/PepWise2.0/ProgramOps_Selected_White.svg';
import { ReactComponent as DataEstateSelectedIcon } from '../../assets/PepWise2.0/D&AI Executive Dashboard_Selected.svg';
import { ReactComponent as StorageWhiteIcon } from '../../assets/PepWise2.0/Storage_White.svg';
import { ReactComponent as StorageIcon } from '../../assets/PepWise2.0/Storage.svg';

import { ReactComponent as QueryWhiteIcon } from '../../assets/PepWise2.0/Query_White.svg';
import { ReactComponent as QueryIcon } from '../../assets/PepWise2.0/Query.svg';

import { ReactComponent as IncidentsWhiteIcon } from '../../assets/PepWise2.0/Incidents_White.svg';
import { ReactComponent as IncidentsIcon } from '../../assets/PepWise2.0/Incidents.svg';

import { ReactComponent as ExecutiveSummaryWhiteIcon } from '../../assets/PepWise2.0/Executive Summary_White.svg';
import { ReactComponent as ExecutiveSummaryIcon } from '../../assets/PepWise2.0/Executive Summary.svg';

import { ReactComponent as DataProcessingWhiteIcon } from '../../assets/PepWise2.0/Data Processing_White.svg';
import { ReactComponent as DataProcessingIcon } from '../../assets/PepWise2.0/Data Processing.svg';

import { ReactComponent as CostWhiteIcon } from '../../assets/PepWise2.0/Cost_White.svg';
import { ReactComponent as CostIcon } from '../../assets/PepWise2.0/Cost.svg';

import { ReactComponent as BIApplicationWhiteIcon } from '../../assets/PepWise2.0/BI Application_White.svg';
import { ReactComponent as BIApplicationIcon } from '../../assets/PepWise2.0/BI Application.svg';

import { ReactComponent as ProgramExecutiveSelectedIcon } from '../../assets/PepWise2.0/Program Executive Dashboards_Selected.svg';
import { ReactComponent as KPIAndAlertsSelectedIcon } from '../../assets/PepWise2.0/Data KPIs & Alerts_Selected.svg';
import { ReactComponent as FinopsSelectedIcon } from '../../assets/PepWise2.0/FinOps DashboardsFinOps Dashboards_Selected.svg';
import { useTheme } from "@mui/material/styles";
import { useRecentVisited } from 'hooks/useRecentVisited';
import { usePepwiseAuthController } from 'Context/contexts/AuthContext';
import { FeedbackLink } from 'Pages/feedback/PepwiseFeedbackForm';
import { hideTeradata, hideML, hideIBPExec, hideRMPlatformCost, hidePresto, hideDMF, hideDG, hideMDIPExec } from 'service/config';
import { FINOPS_EXEC_COST_ROLES, FINOPS_USER_ROLES, FINOPS_ALL_ROLES } from 'components/FinOpsExecutive/finopsRoles';
import { ReactComponent as PipelineRunStatus } from '../../assets/PepWise2.0/Pipeline Run Status.svg';
import { ReactComponent as PipelineRunStatusActiveIcon } from '../../assets/PepWise2.0/Pipeline Run Status_White.svg';
import { RESTRICTED_ROLE_NAMES } from 'utils/common-util';
import { checkRole } from 'utils/roleUtils';
import { removeCapabilities, roleCollection } from 'components/LandingPage/LandingPage';

const COLLAPSED_W = 60;
const EXPANDED_W = 376;

interface MenuItem {
    id: string;
    label: string;
    icon: React.ReactNode;
    iconKey?: string;
    tagline?: string;
    openIcon?: React.ReactNode;
    activeIcon?: React.ReactNode;
    path?: string[];
    hide?: boolean;
    children?: MenuItem[];
}

const platformChildren: MenuItem[] = [
    {
        id: 'teradata',
        label: 'Teradata',
        icon: <TerradataIcon width={24} height={24} />,
        activeIcon: <TerradataActiveIcon width={24} height={24} />,
        iconKey: "Teradata-Jobs",
        hide: hideTeradata,
        tagline: "Monitor jobs scheduled from 2 different schedulers: CTRL-m and Autosys.",
        path: ['/dashboard/business', '/jobs', '/jobExecutions', '/jobSchedules', '/job/Infrastructure']
    },
    {
        id: 'powerbi',
        label: 'Power BI',
        icon: <PowerBIIcon width={24} height={24} />,
        activeIcon: <PowerBIActiveIcon width={24} height={24} />,
        iconKey: "PowerBI",
        tagline: "Monitor and Manage Power BI capacities across PepsiCo for performance, growth and usage.",
        path: ['/powerBI/userActivity']
        // path: ['/powerBI/capacity/dashboard', '/powerBI/dataset/dashboard', '/powerBI/usage/dashboard', '/powerBI/infrastructure/dashboard', '/powerBI/capacityObservability/dashboard', '/powerBI/adoptionMetrics/dashboard', '/powerBI/userActivity/dashboard']
    },
    {
        id: 'tableau',
        label: 'Tableau',
        icon: <TableauIcon width={24} height={24} />,
        activeIcon: <TableauActiveIcon width={24} height={24} />,
        iconKey: "Tableau",
        tagline: "Monitor and manage Tableau servers across PepsiCo for performance, growth and usage.",
        path: ['/tableau/admin/dashboard', '/tableau/admin/reports', '/tableau/admin/cost', '/tableau/performance/dashboard', '/tableau/governance/dashboard', '/tableau/infrastructure/dashboard']
    },
    {
        id: 'datagrowth',
        label: 'Data Growth',
        icon: <DataGrowthIcon width={24} height={24} />,
        activeIcon: <DataGrowthActiveIcon width={24} height={24} />,
        iconKey: "Data-Growth",
        hide: hideDG('some'),
        tagline: "Analyze data growth trends to help teams understand, monitor, and manage their data across the full purview of Teradata.",
        path: ['/dataGrowth/azureStorage', '/dataGrowth/dashboard', '/dataGrowthDataGrowth/dashboard', '/dataGrowthDatabricks/dashboard', '/dataGrowthPresto/dashboard', '/dataGrowthTableau/dashboard']
    },
    {
        id: 'databricks',
        label: 'Databricks',
        icon: <DataBricksIcon width={24} height={24} />,
        activeIcon: <DataBricksActiveIcon width={24} height={24} />,
        iconKey: "Databricks",
        tagline: "Monitor Databricks clusters across PepsiCo to identify usage trends, cost spikes and workspace health.",
        path: ['/databricksADB/workspace', '/databricksADB/jobsADB', '/databricksADB/clusteranalytics', '/databricksADB/dbsqlperfomance', '/databricksADB/costmanagement', '/databricksADB/dbsqlperfomance', '/databricksADB/costmanagement', '/databricksADB/performance-dashboard', '/databricksADB/SQLDetails', '/databricksADB/customanalysis', '/databricksADB/overall-cost', '/databricksADB/total-dbu']
    },
    {
        id: 'presto',
        label: 'Presto',
        icon: <PrestoIcon width={24} height={24} />,
        activeIcon: <PrestoActiveIcon width={24} height={24} />,
        iconKey: "Presto",
        hide: hidePresto,
        tagline: "Monitor Presto usage by identifying long running queries trends of query execution and keep track of usage of data over a period.",
        path: ['/presto/dashboard']
    },
    {
        id: 'dmf',
        label: 'Data Management Framework',
        icon: <DataManagementIcon width={24} height={24} />,
        activeIcon: <DataManagementActiveIcon width={24} height={24} />,
        iconKey: "Data-Management-Framework",
        hide: hideDMF,
        tagline: "Monitor the health of storage accounts across PepsiCo to identify duplicate, redundant and stale data with respect to files and tables. Verify the quality and completeness of data across sectors and projects.",
        path: ['/dataManagementFramework/healthSummary/dashboard', '/dataManagementFramework/Catalogues/dashboard']
    },
    {
        id: 'epmd',
        label: 'Enterprise Platform Modernization Dashboard',
        icon: <EnterprisePlatformIcon width={24} height={24} />,
        activeIcon: <EnterprisePlatformActiveIcon width={24} height={24} />,
        iconKey: "Enterprise-Platform-Modernization-Dashboard",
        tagline: "Automated reports that help monitor, manage and ensure compliance of various legal and regulatory obligations across tools.",
        path: ['/enterprisePlatform/dashboard']
    },
];

// --- THIS IS THE MAIN FIX ---
// The 'governance' item has been removed from both the 'xops' children
// and from the top-level array.
const menuItems: MenuItem[] = [
    {
        id: 'dataestateExecutive',
        label: 'D&AI Executive Dashboard',
        icon: <DataEstateIcon width={40} height={40} />,
        openIcon: <DataEstateSelectedIcon width={40} height={40} />,
        iconKey: "D&AIExecutive",
        children: [
                    {
                    id: 'executive-summary',
                    label: 'Executive Summary',
                    icon: <ExecutiveSummaryIcon  width={24} height={24} />,
                    activeIcon: <ExecutiveSummaryWhiteIcon width={24} height={24} />,
                    iconKey: "de-executive-summary",
                    path: ['/dataestate/executive-summary']
                    },
                    {
                    id: 'storage-summary',
                    label: 'Storage',
                    icon: <StorageIcon width={24} height={24} />,
                    activeIcon: <StorageWhiteIcon width={24} height={24} />,
                    iconKey: "de-storage-summary",
                    path: ['/dataestate/storagesummary']
                    },
                    {
                    id: 'queries-summary',
                    label: 'Query',
                    icon: <QueryIcon width={24} height={24} />,
                    activeIcon: <QueryWhiteIcon width={24} height={24} />,
                    iconKey: "de-queries-summary",
                    path: ['/dataestate/queriessummary']
                    },
                    {
                    id: 'data-processing',
                    label: 'Data Processing',
                    icon: <DataProcessingIcon width={24} height={24} />,
                    activeIcon: <DataProcessingWhiteIcon width={24} height={24} />,
                    iconKey: "de-data-processing",
                    path: ['/dataestate/data-processing']
                    },
                    {
                    id: 'bi-summary',
                    label: 'BI Application',
                    icon: <BIApplicationIcon width={24} height={24} />,
                    activeIcon: <BIApplicationWhiteIcon width={24} height={24} />,
                    iconKey: "de-bi-summary",
                    path: ['/dataestate/biApplicationSummary']
                    },
                    {
                    id: 'major-incident',
                    label: 'Major INC',
                    icon: <IncidentsIcon width={24} height={24} />,
                    activeIcon: <IncidentsWhiteIcon width={24} height={24} />,
                    iconKey: "de-major-incident",
                    path: ['/dataestate/majorIncident']
                    }
                ]
    },
    {
        id: 'xops',
        label: 'D&AI Monthly XOps',
        icon: <XopsIcon width={40} height={40} />,
        iconKey: "D&AIMonthlyXOps",
        openIcon: <XopsSelectedIcon width={40} height={40} />,
        children: [
            {
                id: 'xops-summary',
                label: 'XOps Overview',
                path: ['/D&AIXOps/Summary'],
                icon: <DataOpsIcon width={24} height={24} />,
            },
            {
                id: 'xops-experience',
                label: 'Experience Management',
                path: ['/D&AIXOps/experience/HappySignals'],
                icon: <DataOpsIcon width={24} height={24} />,
            },
            {
                id: 'xops-it-ops-itsm-type',
                label: 'ITSM Operations Dashboards - By ITSM Type',
                path: ['/D&AIXOps/itsm/MIMReports'],
                icon: <DataOpsIcon width={24} height={24} />,
            },
            {
                id: 'xops-it-ops-segments',
                label: 'ITSM Operations Dashboards - By Segments',
                path: ['/D&AIXOps/segments/DepartmentMetrics', '/D&AIXOps/segments/SectorMetrics', '/D&AIXOps/segments/capability', '/D&AIXOps/segments/programMetrics', '/D&AIXOps/segments/Apps-Products'],
                icon: <DataOpsIcon width={24} height={24} />,
                children: [
                    {
                        id: 'xops-it-ops-segments-capabilities',
                        label: 'Capability',
                        path: ['/D&AIXOps/segments/capability/pipelineMatrics', '/D&AIXOps/segments/capability/platformOpsMatrics','/D&AIXOps/segments/capability/DepartmentLevelMetrics','/D&AIXOps/segments/capability/AIMLMetrics', '/D&AIXOps/segments/capability/DMOMetrics'],
                        icon: <DataOpsIcon width={24} height={24} />,
                    },
                ]
            },
            {
                id: 'xops-service',
                label: 'Service Operations',
                icon: <DataOpsIcon width={24} height={24} />,
                activeIcon: <DataSustainActiveIcon width={24} height={24} />,
                iconKey: "service-op",
                path: ['/D&AIXOps/service/BAICenter', '/D&AIXOps/service/KOREIHub', '/D&AIXOps/service/OPSICenter' ],

            },
            {
                id: 'xops-dai-component-inv',
                label: 'D&AI Component Inventory',
                path: ['#'],
                icon: <DataOpsIcon width={24} height={24} />,
            },
            {
                id: 'xops-misc',
                label: 'Miscellaneous Dashboards',
                path: ['/D&AIXOps/misc/topicOfTheMonth'],
                icon: <DataOpsIcon width={24} height={24} />,
            },
        ]
    },
    {
        id: 'data-obs',
        label: 'Data Pipeline Observability',
        icon: <DataObservabilityIcon width={40} height={40} />,
        iconKey: "DataPipeline",
        openIcon: <DataOpsClickedIcon width={40} height={40} />,
        children: [
            {
                id: 'dataops',
                label: 'DataOps Sustain',
                icon: <DataOpsIcon width={24} height={24} />,
                activeIcon: <DataSustainActiveIcon width={24} height={24} />,
                iconKey: "dp-sustain",
                tagline: "Monitor jobs or pipelines for a specific project.",
                path: ['/data-pipeline/dataOps', '/data-pipeline/programs-tab', '/data-pipeline/executiveTemplate', '/data-pipeline/programs', '/data-pipeline/projects']
            },
            {
                id: 'program',
                label: 'Program Ops Dashboards',
                icon: <ProgramOpsIcon width={24} height={24} />,
                activeIcon: <ProgramOpsActiveIcon width={24} height={24} />,
                iconKey: "dp-program",
                tagline: "Observe custom Grafana dashboards.",
                path: ['/data-pipeline/programOpsDashboard', '/data-pipeline/programOps']
            },
            {
                id: 'sector',
                label: 'End to End Observability Dashboard',
                icon: <SectorExecutiveIcon width={24} height={24} />,
                activeIcon: <SectorExecutiveActiveIcon width={24} height={24} />,
                iconKey: "dp-sector",
                tagline: "Monitor jobs or pipelines for a specific project.",
                path: ['/data-pipeline/home/executiveOps', '/data-pipeline/executiveOps/sector', '/data-pipeline/executiveOps/program', '/data-pipeline/projects', '/data-pipeline/executiveTemplate', '/data-pipeline/executiveOps/pepsellPepIrisRecon']
            },
            {
                id: 'platformHealth',
                label: 'Platform Health',
                icon: <PlatformHealthIcon width={24} height={24} />,
                activeIcon: <PlatformHealthActiveIcon width={24} height={24} />,
                iconKey: "PlatformHealth",
                tagline: "Monitor platform health across PepsiCo for performance, growth and usage.",
                path: ['/dataOps/platformHealth/summary']
            },
            {
                id: 'alerts',
                label: 'Pipeline Early Warning System',
                icon: <AlertIcon width={24} height={24} />,
                activeIcon: <AlertActiveIcon width={24} height={24} />,
                iconKey: "Alerts",
                tagline: "Monitor pipeline health across Pepsico for the alerts and early notifications.",
                path: ['/dataops/unified-alerts']
            },
            {
                id: 'earlyWarningRule',
                label: 'Summary',
                icon: <AlertIcon width={24} height={24} />,
                activeIcon: <AlertActiveIcon width={24} height={24} />,
                iconKey: "EarlyWarningRule",
                tagline: "Manage rules for early warnings.",
                path: ['/dataops/early-warning-rule'],
                hide: true
            },
            {
                id: 'incidents',
                label: 'Ops Pulse Dashboard',
                icon: <IncidentsIcon width={24} height={24} />,
                activeIcon: <IncidentsWhiteIcon width={24} height={24} />,
                iconKey: "Incidents",
                tagline: "Unified view of data platform incidents across all observability tools.",
                path: ['/dataops/unified-incidents']
            },
            {
                id: 'pipelineRunStatus',
                label: 'Integrated Job Monitoring Dashboard',
                icon: <PipelineRunStatus width={24} height={24} />,
                activeIcon: <PipelineRunStatusActiveIcon width={24} height={24} />,
                iconKey: "PipelineRunStatus",
                tagline: "Realtime tracking of pipeline runs.",
                path: ['/dataOps/integratedJobMonitoring']
            },
            {
                id: 'crossflowNavigator',
                label: 'CrossFlow Navigator',
                icon: <DataOpsIcon width={24} height={24} />,
                activeIcon: <DataSustainActiveIcon width={24} height={24} />,
                iconKey: "CrossFlowNavigator",
                tagline: "Interactive graph and reports for enterprise data flows.",
                path: ['/dataOps/crossFlowNavigator']
            },
                ]
    },
    {
        id: 'program-exec',
        label: 'Program Executive Dashb...',
        icon: <ProgramExecutiveIcon width={40} height={40} />,
        iconKey: "ProgramExecutive",
        hide: hideIBPExec && hideMDIPExec,
        openIcon: <ProgramExecutiveSelectedIcon width={40} height={40} />,
        children: [
            {
                id: 'ibp',
                label: 'Integrated Business Planning (IBP)',
                icon: <IbpIcon width={24} height={24} />,
                activeIcon: <IbpActiveIcon width={24} height={24} />,
                iconKey: "ibp",
                hide: hideIBPExec,
                tagline: "Monitoring the IBP Turkey data landscape across the EDAP platforms leveraged.",
                path: ['/ibp/pipelines', '/ibp/dashboard', '/ibp/executive', '/ibp/bdr-pbi']
            },
            {
                id: 'mdip',
                label: 'MDIP Executive Dashboard',
                icon: <MdipIcon width={24} height={24} />,
                activeIcon: <MdipActiveIcon width={24} height={24} />,
                iconKey: "mdip",
                hide: hideMDIPExec,
                tagline: "Real-time dashboard-key metrics & insights for strategic decisions.",
                path: ['/mdip/dashboard', '/mdip/job']
            }
        ]
    },
    {
        id: 'platform',
        label: 'Platform Observability',
        icon: <PlatformIcon width={40} height={40} />,
        iconKey: "PlatformObservability",
        openIcon: <PlatformSelectedIcon width={40} height={40} />,
        children: platformChildren
    },
    {
        id: 'finopsExec',
        label: 'Finops Executive',
        icon: <XopsIcon width={40} height={40} />,
        iconKey: 'finOpsIcon',
        path: ['/finops/executive']
    },
    {
        id: 'ml-obs',
        label: 'ML Observability',
        icon: <MLIcon width={40} height={40} />,
        iconKey: 'mlObservability',
        path: ['/machineLearning/dashboard', '/machineLearning/models']
    },
    // --- 'governance' top-level item removed from here ---
    {
        id: 'kpis',
        label: 'Data KPIs & Alerts',
        icon: <KpiIcon width={40} height={40} />,
        iconKey: 'DataKPI-and-Alerts',
        openIcon: <KPIAndAlertsSelectedIcon width={40} height={40} />,
        children: [
            {
                id: 'KpiStore',
                label: 'KPI Store',
                icon: <KPIStoreIcon width={24} height={24} />,
                activeIcon: <KPIStoreActiveIcon width={24} height={24} />,
                iconKey: "KPIStore",
                tagline: "Stay ahead with live monitoring of critical data KPIs.",
                path: ['/kpiFramework/configs']
            },
            {
                id: 'AlertFramework',
                label: 'Alert Framework',
                icon: <AlertIcon width={24} height={24} />,
                activeIcon: <AlertActiveIcon width={24} height={24} />,
                iconKey: "Alert-Framework",
                tagline: "Detect issues before they impact business with near real-time notifications.",
                path: ['/alertFramework/alert', '/alertFramework/createalert', '/alert-details']
            }
        ]
    },
    {
        id: 'productCatalogExecutive',
        label: 'Product Catalog',
        icon: <ProductCatalogIcon width={40} height={40} />,
        iconKey: "ProductCatalog",
        path: ['/productCatalog/overview']
    },
    {
        id: 'productSuccess',
        label: 'Product Success',
        icon: <ProductSuccessIcon width={40} height={40} />,
        iconKey: "ProductSuccess",
        path: ['/productSuccessDashboard/userAdoption']
    },
    {
        id: 'xopsIntelligence',
        label: 'XOPs Intelligence',
        icon: <XopsIntelligenceIcon width={40} height={40} />,
        iconKey: "xopsIntelligence",
        path: ['/dashboard/xops-intelligence']
    }
];

/** ---------- Utility ---------- */
const isPathActive = (current: string, targets?: string[], hasSectorParam?: boolean) => {
    if (current.startsWith('/data-pipeline/executiveTemplate') || current.startsWith('/data-pipeline/projects/')) {
        if ((targets?.includes('/data-pipeline/dataOps') && hasSectorParam) ||
            (targets?.includes('/data-pipeline/executiveOps') && !hasSectorParam)) {
            return false;
        }
    }
    return targets?.includes(current) || targets?.some(target => current.startsWith(target + '/'));
};

const anyChildActive = (current: string, children?: MenuItem[]) => {
    return children?.some(c => isPathActive(current, c.path));
};

/** ---------- Component ---------- */
const GlobalSidebar: React.FC<{
    collapsedWidth?: number;
    expandedWidth?: number;
}> = ({ collapsedWidth = COLLAPSED_W, expandedWidth = EXPANDED_W }) => {
    const theme = useTheme();
    const colors = theme.palette;
    const BRAND = colors.textLight.sideNavMain;
    const BG = colors.backgroundLight.sideNavBG;
    const ITEM_HOVER = colors.backgroundLight.sideNavBgHover;
    const TEXT = BRAND;

    const [pinnedOpen] = useState(false); // click to pin expanded
    const [hoverOpen, setHoverOpen] = useState(false); // expand on hover
    const [openMenuId, setOpenMenuId] = useState<string | null>(null);
    const [kbdOpen, setKbdOpen] = useState(false);
    const location = useLocation();
    const navigate = useNavigate();
    const drawerRef = useRef<HTMLDivElement | null>(null);

    const searchParams = new URLSearchParams(location.search);
    const hasSectorParam = ((location.pathname.includes('/data-pipeline/executiveTemplate') && searchParams.has('sector')) || 
        (location.pathname.includes('/data-pipeline/projects/') && searchParams.has('isSector')));

    const [controller] = usePepwiseAuthController();
    const { capabilities, role } = controller;

    const isRestricted = checkRole(role, RESTRICTED_ROLE_NAMES);

    const isOnLandingPage = location.pathname === '/LandingPage';
    const drawerWidth = pinnedOpen || hoverOpen || kbdOpen ? expandedWidth : collapsedWidth;

    const { addVisited } = useRecentVisited();

    const platformObsCapabilities = [
        'EDW Jobs',
        'Tableau',
        'Data Growth',
        'Databricks',
        'Presto',
        'Power BI',
        'Data Management Framework',
        'Controls & Compliance',
        'Verification & Validation'
    ];

    const filteredCapabilities = useMemo(() => {
        if (!role || !capabilities) return capabilities;

        if (role.every((r: string) => roleCollection.includes(r))) {
            return capabilities.filter(
                (cap: string) => !removeCapabilities.includes(cap)
            );
        }

        return capabilities;
    }, [role, capabilities]);

    const isPlatformObsVisible = platformObsCapabilities.some((cap) => (filteredCapabilities ?? []).includes(cap));

    // Filter top-level menu items
    const filteredMenuItems = menuItems.filter((item) => {
        // Skip items that have hide property set to true
        if (item.hide) {
            return false;
        }

        switch (item.id) {
            case 'dataestateExecutive':
                return (filteredCapabilities ?? []).includes('Data Estate');
            case 'xops':
                return (filteredCapabilities ?? []).includes('Data Estate', 'Fin Ops') || isPlatformObsVisible;
            case 'data-obs':
                return (filteredCapabilities ?? []).includes('Data Ops');
            case 'program-exec':
                return (filteredCapabilities ?? []).includes('IBP');
            case 'platform':
                return isPlatformObsVisible;
            case 'finopsExec':
                return checkRole(role, FINOPS_ALL_ROLES);
            case 'ml-obs':
                return (filteredCapabilities ?? []).includes('Machine Learning') && !hideML;
            case 'kpis':
                return (filteredCapabilities ?? []).includes('Data KPI and Alerts');
            // --- FIX: Removed the 'governance' case from this filter ---
            case 'productCatalogExecutive':
                return (filteredCapabilities ?? []).includes('Product Catalog');
            case 'productSuccess':
                return (filteredCapabilities ?? []).includes('Product Success') || isPlatformObsVisible;
            case 'xopsIntelligence':
                return (filteredCapabilities ?? []).includes('Data Ops');
            default:
                return false;
        }
    });


	function recordAndGo({
		id,
		title,
		route,
		kind,
		iconKey,
		tagline,
	}: {
		id: string;
		title: string;
		route: string;
		kind: 'parent' | 'child';
		iconKey?: string;
		tagline?: string;
	}) {
        if (id !== 'xopsIntelligence') {
		    addVisited({ id, title, route, kind, iconKey, tagline });
        }
		navigate(route);
	}

    useEffect(() => {
        if (!pinnedOpen && !hoverOpen && !kbdOpen) {
            setOpenMenuId(null);
        }
    }, [pinnedOpen, hoverOpen, kbdOpen]);

    const model = filteredMenuItems

    const toggleMenu = useCallback((id: string) => {
        setOpenMenuId(prev => (prev === id ? null : id));
    }, []);

    // move focus among visible siblings (current UL scope)
    const moveFocus = (currentEl: HTMLElement, dir: 'next' | 'prev' | 'first' | 'last') => {
        const list = currentEl.closest('ul');
        if (!list) return;
        const items = Array.from(list.querySelectorAll<HTMLElement>('[role="menuitem"]'))
            .filter(el => !el.hasAttribute('disabled'));
        const idx = items.indexOf(currentEl);
        if (idx < 0) return;

        let target: HTMLElement | undefined;
        if (dir === 'first') target = items[0];
        else if (dir === 'last') target = items.at(-1);
        else if (dir === 'next') target = items[Math.min(idx + 1, items.length - 1)];
        else target = items[Math.max(idx - 1, 0)];

        target?.focus();
    };

    // focus first child of a just-opened parent section
    const focusFirstChild = (parentId: string, root?: HTMLElement | null) => {
        const firstChildBtn = (root ?? document).querySelector<HTMLElement>(`#${parentId}-collapse [role="menuitem"]`);
        firstChildBtn?.focus();
    };

    const handleDrawerKeyDown = useCallback((e: React.KeyboardEvent) => {
        const navKeys = ['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'Home', 'End', 'Enter', ' '];
        if (navKeys.includes(e.key)) {
            setKbdOpen(true);
        }
    }, []);


    /** keyboard accessibility for toggling & navigation */
    const handleItemKey = useCallback(
        (e: React.KeyboardEvent, item: MenuItem, hasChildren: boolean) => {
            const key = e.key;
            const target = e.currentTarget as HTMLElement;
            const drawerElement = (drawerRef.current as unknown as HTMLElement) ?? undefined;

            const handleArrowRight = () => {
                if (!hasChildren) return;

                e.preventDefault();
                setKbdOpen(true);

                if (openMenuId === item.id) {
                    // already open -> move focus into first child
                    focusFirstChild(item.id, drawerElement);
                    return;
                }

                toggleMenu(item.id);
                // focus first child after opening
                setTimeout(() => focusFirstChild(item.id, drawerElement), 0);
            };

            switch (key) {
                case 'Enter':
                case ' ':
                    e.preventDefault();
                    if (hasChildren) {
                        setKbdOpen(true);       // keep menu open for keyboard users
                        toggleMenu(item.id);
                    } else if (item.path) {
                        navigate(item.path[0]);
                    }
                    break;

                case 'ArrowRight':
                    handleArrowRight();
                    break;

                case 'ArrowLeft':
                    if (hasChildren && openMenuId === item.id) {
                        e.preventDefault();
                        toggleMenu(item.id);
                    }
                    // if already collapsed, ArrowLeft does nothing at parent level
                    break;

                case 'ArrowDown':
                    e.preventDefault();
                    moveFocus(target, 'next');
                    break;

                case 'ArrowUp':
                    e.preventDefault();
                    moveFocus(target, 'prev');
                    break;

                case 'Home':
                    e.preventDefault();
                    moveFocus(target, 'first');
                    break;

                case 'End':
                    e.preventDefault();
                    moveFocus(target, 'last');
                    break;

                default:
                    break;
            }
        },
        [navigate, openMenuId, toggleMenu]
    );

    const goHome = useCallback(() => {
        if (!isOnLandingPage) {
            navigate('/LandingPage');
        }
    }, [location.pathname, navigate]);

    const getItemBgColor = (itemActive: boolean, isOpen: boolean) => {
        if (itemActive) {
            return `${colors.backgroundLight.sideNavHighlightBG} !important`;
        }

        if (isOpen) {
            return `${colors.backgroundLight.sideNavExpandBg} !important`;
        }

        return `${BG} !important`;
    };

    const getItemDisplayIcon = (
        item: MenuItem,
        isOpen: boolean,
        hoverOpen: boolean,
        kbdOpen: boolean
    ) => {
        if ((hoverOpen || kbdOpen) && isOpen && item.openIcon) {
            return item.openIcon;
        }

        return item.icon;
    };

    const getPrimaryTextColor = (isOpen: boolean, itemActive: boolean) => {
        if (!isOpen) {
            return BRAND;
        }

        if (itemActive) {
            return colors.textLight.light;
        }

        return colors.textLight.sideNavDark;
    };

    const getHoverTextColor = (isOpen: boolean) => {
        if (isOpen) {
            return colors.textLight.sideNavDark;
        }

        return BRAND;
    };

    const getChildBgColor = (childActive: boolean, isOpen: boolean) => {
        if (childActive) {
            return `${colors.backgroundLight.sideNavHighlightBG} !important`;
        }

        if (isOpen) {
            return `${colors.backgroundLight.sideNavExpandBg} !important`;
        }

        return `${BG} !important`;
    };

    const getChildTextColor = (childActive: boolean) => {
        if (childActive) {
            return `${colors.textLight.light} !important`;
        }

        return `${colors.textLight.sideNavDark} !important`;
    };

    const getChildHoverTextColor = (isOpen: boolean, childActive: boolean) => {
        if (isOpen && childActive) {
            return `${colors.textLight.light} !important`;
        }

        return `${colors.textLight.sideNavDark} !important`;
    };

    const handleChildKeyDown = (
        e: React.KeyboardEvent,
        child: MenuItem,
        itemId: string
    ) => {
        switch (e.key) {
            case 'Enter':
            case ' ':
                if (child.path) {
                    e.preventDefault();
                    recordAndGo({
                        id: child.id,
                        title: child.label,
                        route: child.path[0],
                        kind: 'child',
                        tagline: child.tagline,
                        iconKey: (child as any).iconKey ?? child.id,
                    });
                }
                break;

            case 'ArrowDown':
                e.preventDefault();
                moveFocus(e.currentTarget as HTMLElement, 'next');
                break;

            case 'ArrowUp':
                e.preventDefault();
                moveFocus(e.currentTarget as HTMLElement, 'prev');
                break;

            case 'Home':
                e.preventDefault();
                moveFocus(e.currentTarget as HTMLElement, 'first');
                break;

            case 'End':
                e.preventDefault();
                moveFocus(e.currentTarget as HTMLElement, 'last');
                break;

            case 'ArrowLeft': {
                e.preventDefault();
                // move focus back to the parent button that controls this collapse
                const parentBtn = (drawerRef.current as unknown as HTMLElement | null)?.querySelector<HTMLElement>(
                    `[aria-controls="${itemId}-collapse"]`
                );
                parentBtn?.focus();
                break;
            }

            default:
                break;
        }
    };

    return (
        <Drawer
            ref={drawerRef}
            variant="permanent"
            onKeyDown={handleDrawerKeyDown}
            // onFocusCapture={() => setKbdOpen(true)}
            onBlurCapture={(e) => {
                const next = e.relatedTarget as HTMLElement | null;
                const root = drawerRef.current;
                if (root && next && root.contains(next)) return; // still inside
                if (!pinnedOpen && !hoverOpen) setKbdOpen(false);
            }}
            onMouseEnter={() => setHoverOpen(true)}
            onMouseLeave={() => setHoverOpen(false)}
            sx={{
                width: drawerWidth,
                flexShrink: 0,
                '& .MuiDrawer-paper': {
                    width: drawerWidth,
                    bgcolor: `${BG} !important`,
                    color: `${TEXT} !important`,
                    boxShadow: '30px 0 30px rgba(0, 0, 0, 0.1) !important',
                    transition: 'width 180ms ease',
                    overflowX: 'hidden',
                    '&::-webkit-scrollbar': {
                        width: '6px',
                    },
                    '&::-webkit-scrollbar-thumb': {
                        backgroundColor: `${colors.textLight?.sideNavMain}`,
                        borderRadius: '4px',
                    },
                    '&::-webkit-scrollbar-track': {
                        borderRadius: '4px',
                    },
                    '& .MuiListItemButton-root': {
                        border: 'none !important',
                        outline: 'none !important',
                        WebkitTapHighlightColor: 'transparent',    //remove tap highlight
                    },
                    '& .MuiListItemButton-root + .MuiListItemButton-root': {
                        borderTop: 'none !important',
                        borderBottom: 'none !important',
                    },
                }
            }}
        >
            {/* Header / Brand */}
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: `${colors.backgroundLight.sideNavLogoBg} !important` }}>
                {!pinnedOpen && !hoverOpen && !kbdOpen && (
                    <Box sx={{ bgcolor: `${colors.backgroundLight.sideNavLogoBg} !important` }}>
                        <Tooltip title="Home" disableInteractive>
                            <Box aria-label="Home" onClick={goHome} sx={{ p: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', height: 60, width: 60, bgcolor: `${colors.backgroundLight.sideNavLogoBg} !important` }}>
                                <PepwiseLogoIcon width={30} height={37} />
                            </Box>
                        </Tooltip>
                    </Box>
                )}

                {(pinnedOpen || hoverOpen || kbdOpen) && (
                    <Box sx={{ width: '100%', bgcolor: `${colors.backgroundLight.sideNavLogoBg} !important` }}>
                        <Box
                            aria-label="Home"
                            onClick={goHome}
                            sx={{
                                pl: 2.5,
                                width: 376,
                                height: 70,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'flex-start'
                            }}
                        >
                            <PepwiseLogo width={208} height={47} />
                        </Box>
                    </Box>
                )}
            </Box>

            {/* Nav list */}
            <List id="sidebar-global" role="menu" aria-label="PepWise global navigation" disablePadding dense>
                {model.map((item) => {
                    const hasChildren = !!item.children?.length;
                    const groupActive = hasChildren ? Boolean(anyChildActive(location.pathname, item.children)) : false;
                    const isOpen = openMenuId === item.id;
                    const itemActive = !isOpen && (Boolean(isPathActive(location.pathname, item.path)) || groupActive);

                    const itemBgColor = getItemBgColor(itemActive, isOpen);
                    const itemDisplayIcon = getItemDisplayIcon(item, isOpen, hoverOpen, kbdOpen);
                    const primaryTextColor = getPrimaryTextColor(isOpen, itemActive);
                    const hoverTextColor = getHoverTextColor(isOpen);

                    return (
                        <React.Fragment key={item.id}>
                            <ListItemButton
                                role="menuitem"
                                tabIndex={0}
                                onKeyDown={(e) => handleItemKey(e, item, hasChildren)}
                                onClick={() => {
                                    if (hasChildren) {
                                        toggleMenu(item.id);
                                    } else if (item.path) {
                                        recordAndGo({
                                            id: item.id,
                                            title: item.label,
                                            route: item.path[0],
                                            kind: 'parent',
                                            tagline: item.tagline,
                                            iconKey: (item as any).iconKey
                                        });
                                    }
                                }}
                                sx={{
                                    px: 2,
                                    Py: 3,
                                    minHeight: 44,
                                    height: 60,
                                    bgcolor: itemBgColor,
                                    '&.Mui-focusVisible': { bgcolor: `${ITEM_HOVER} !important`, color: `${colors.textLight.sideNavMain} !important` },
                                    '&:hover': { bgcolor: `${ITEM_HOVER} !important`, color: `${colors.textLight.sideNavMain} !important` },
                                    justifyContent: pinnedOpen || hoverOpen || kbdOpen ? 'flex-start' : 'center'
                                }}
                                aria-expanded={hasChildren ? isOpen : undefined}
                                aria-controls={hasChildren ? `${item.id}-collapse` : undefined}
                            >
                                <ListItemIcon
                                    sx={{
                                        minWidth: 0,
                                        mr: pinnedOpen || hoverOpen || kbdOpen ? 2 : 'auto'
                                    }}
                                >
                                    {itemDisplayIcon}
                                </ListItemIcon>

                                {(pinnedOpen || hoverOpen || kbdOpen) && (
                                    <ListItemText
                                        primaryTypographyProps={{
                                            variant: "sidebarMain",
                                            noWrap: true,
                                            color: primaryTextColor,
                                            lineHeight: '25px',
                                            fontStyle: 'Montserrat',
                                            sx: {
                                                '.MuiListItemButton-root:hover &': {
                                                    color: hoverTextColor,
                                                },
                                            }
                                        }}
                                        primary={item.label}
                                    />
                                )}

                                {(pinnedOpen || hoverOpen || kbdOpen) && hasChildren && (
                                    <IconButton
                                        size="small"
                                        aria-label={isOpen ? 'Collapse section' : 'Expand section'}
                                        edge="end"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            toggleMenu(item.id);
                                        }}
                                        sx={{ ml: 'auto' }}
                                    >
                                        {isOpen ? (
                                            <ExpandLess sx={{ color: `${colors.textLight.sideNavDark} !important` }} />
                                        ) : (
                                            <ExpandMore sx={{ color: `${BRAND} !important` }} />
                                        )}
                                    </IconButton>
                                )}
                            </ListItemButton>

                            {hasChildren && (
                                <Collapse in={(hoverOpen || pinnedOpen || kbdOpen) && isOpen} timeout={150} unmountOnExit id={`${item.id}-collapse`}>
                                    <List role="group" disablePadding dense>
                                        {item.children!.map((child) => {
                                            const childActive = Boolean(isPathActive(location.pathname, child.path, hasSectorParam));

                                            const isRestrictedChild = (item.id === 'data-obs' && (child.id === 'program' || child.id === 'sector') && isRestricted);
                                            
                                            if (child.hide || isRestrictedChild) return null;

                                            const childBgColor = getChildBgColor(childActive, isOpen);
                                            const childTextColor = getChildTextColor(childActive);
                                            const childHoverTextColor = getChildHoverTextColor(isOpen, childActive);

                                            return (
                                                <ListItemButton
                                                    key={child.id}
                                                    role="menuitem"
                                                    component={child.path ? RouterLink : 'button'}
                                                    to={child.path ? child.path[0] : ''}
                                                    onClick={() => {
                                                        if (child.path) {
                                                            recordAndGo({
                                                                id: child.id,
                                                                title: child.label,
                                                                route: child.path[0],
                                                                kind: 'child',
                                                                tagline: child.tagline,
                                                                iconKey: (child as any).iconKey
                                                            });
                                                        }
                                                    }}
                                                    tabIndex={0}
                                                    sx={{
                                                        pl: pinnedOpen || hoverOpen || kbdOpen ? 6 : 1.5,
                                                        minHeight: 40,
                                                        justifyContent: pinnedOpen || hoverOpen || kbdOpen ? 'flex-start' : 'center',
                                                        bgcolor: childBgColor,
                                                        '&.Mui-focusVisible': { bgcolor: childActive ? `${colors.backgroundLight.sideNavHighlightBG} !important` : `${ITEM_HOVER} !important`, color: `${colors.textLight.sideNavMain} !important` },
                                                        '&:hover': {
                                                            bgcolor: childActive ? `${colors.backgroundLight.sideNavHighlightBG} !important` : `${ITEM_HOVER} !important`,
                                                            color: `${colors.textLight.light} !important`
                                                        }
                                                    }}
                                                    onKeyDown={(e: any) => handleChildKeyDown(e, child, item.id)}
                                                >
                                                    <ListItemIcon
                                                        sx={{
                                                            color: `${BRAND} !important`,
                                                            minWidth: 0,
                                                            mr: pinnedOpen || hoverOpen || kbdOpen ? 2 : 'auto'
                                                        }}
                                                    >
                                                        {(isOpen && childActive && child.activeIcon) ? child.activeIcon : child.icon}
                                                    </ListItemIcon>

                                                    {(pinnedOpen || hoverOpen || kbdOpen) && (
                                                        <ListItemText
                                                            primaryTypographyProps={{
                                                                noWrap: true,
                                                                color: childTextColor,
                                                                sx: {
                                                                    '.MuiListItemButton-root:hover &': {
                                                                        color: childHoverTextColor
                                                                    }
                                                                }
                                                            }}
                                                            // primary={child.label}
                                                            primary={
                                                                <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 0.5, minWidth: 0 }}>
                                                                    <Typography
                                                                        noWrap
                                                                        variant="sidebarChild"
                                                                        sx={{
                                                                            color: childTextColor,
                                                                            '.MuiListItemButton-root:hover &': {
                                                                                color: childHoverTextColor,
                                                                            },
                                                                        }}
                                                                    >
                                                                        {/* if your child.label is a string or node, render it safely */}
                                                                        {typeof child.label === 'string' ? child.label : 'Summary'}
                                                                    </Typography>
                                                                </Box>
                                                            }
                                                        />
                                                    )}
                                                </ListItemButton>
                                            );
                                        })}
                                    </List>
                                </Collapse>
                            )}
                        </React.Fragment>
                    );
                })}
            </List>

            {/* Footer spacer to avoid scroll cutoff */}
            <Box sx={{ flexGrow: 1, bgcolor: `${BG} !important` }} />
            <FeedbackLink />
        </Drawer>
    );
};

export default React.memo(GlobalSidebar);